<template>
  <nav class="pagination-container" id="pagination-template">
    <!-- PC 화면은 10페이지씩, MO 화면은 5페이지씩 -->
    <!-- BEGIN PC 버전 -->
    <ul class="pagination pc-only" :class="isPc? 'pc-only' : 'mo-only'">
      <li class="page-item" :class="{disabled: currentPage < size}"><a class="page-link btn-page" href="#" @click.prevent="goFirst" title="첫 페이지">&laquo;</a></li>
      <li class="page-item" :class="{disabled: currentPage <= 1}"><a class="page-link btn-page" href="#" @click.prevent="goPrev" title="이전 페이지">&lsaquo;</a></li>
      <li class="page-item" :class="{active: page === currentPage}" v-for="page in pageRange(minPage, maxPage)" :key="page">
        <a class="page-link" href="#" @click.prevent="transParentPage(page)" title="{{ page }} 페이지">{{ page }}</a>
      </li>
      <li class="page-item" :class="{disabled: currentPage >= maxPage}"><a class="page-link btn-page" href="#" @click.prevent="goNext" title="다음 페이지">&rsaquo;</a></li>
      <li class="page-item" :class="{disabled: currentPage >= maxPage-size}"><a class="page-link btn-page" href="#" @click.prevent="goLast" title="마지막 페이지">&raquo;</a></li>
    </ul>
  </nav>
</template>

<script>
export default ({
  name: 'pagination-template',
  props: ['totalPages', 'currentPage', 'size'],
  data() {
    return {
      isPc: true,
      isMo: false,
      url: location.href,
    };
  },
  watch: {
    size: {
      handler(newVal) {
        if (newVal === 5) {
          this.isPc = false;
          this.isMo = true;
        } else {
          this.isPc = true;
          this.isMo = false;
        }
      },
      immediate: true,
    },
    // totalPages: {
    //   handler(newVal) {
    //     this.minPage = this.currentPage - ((this.currentPage - 1) % this.size);
    //     const calculatedMaxPage = this.minPage + (this.size - 1);
    //     this.maxPage = (calculatedMaxPage > newVal) ? newVal : calculatedMaxPage;
    //   },
    //   immediate: true,
    // }
  },
  computed: {
    minPage() {
      return this.currentPage - ((this.currentPage - 1) % this.size);
    },
    maxPage() {
      const calculatedMaxPage = this.minPage + (this.size - 1);
      return (calculatedMaxPage > this.totalPages) ? this.totalPages : calculatedMaxPage;
    },
  },
  methods: {
    pageRange(stat, end) {
      const range = [];
      for (let i = stat; i < end + 1; i += 1) {
        range.push(i);
      }
      return range;
    },
    transParentPage(newPageNum) {
      this.$emit('update:currentPage', newPageNum);
    },
    goFirst() {
      this.$emit('update:currentPage', 1);
    },
    goPrev() {
      this.$emit('update:currentPage', this.currentPage - 1);
    },
    goNext() {
      this.$emit('update:currentPage', this.currentPage + 1);
    },
    goLast() {
      this.$emit('update:currentPage', this.totalPages);
    },
  },
  mounted() {
  },
});
</script>



// WEBPACK FOOTER //
// Pagination.vue?37ba5573